import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Drawer,
  Divider,
} from "@mui/material";
import React, { useState, useEffect } from "react";
// import hrIcon from "../../assets/ClikkleFavicons/hr.png";
// import filesIcon from "../../assets/ClikkleFavicons/file.png";
// import mastercardImage from "../../assets/mastercard.png";
import moment from "moment";
import visaImg from "../../assets/cards/visa.png";
import amexImg from "../../assets/cards/amex.png";
import dinersImg from "../../assets/cards/diners.jpg";
import discoverImg from "../../assets/cards/discover.jpg";
import jcbImg from "../../assets/cards/jcb.jpg";
import cartesImg from "../../assets/cards/cartes_bancaires.png";
import unionpayImg from "../../assets/cards/union.png";
import masterImg from "../../assets/cards/master.png";
import Image from "../Image";
import { useTheme as useCustomTheme } from "../../style/theme";

const ActivityDetails = ({ data = [] }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  console.log(data, "datdat");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [open, setOpen] = useState(false);
  const [CardImg, setCardImg] = useState("visa");
  const [notification, setSelectedNotification] = useState(null);

  const toggleDrawer = (value, data) => () => {
    setSelectedNotification(data);
    setOpen(value);
    setCardImg(
      data?.subscriptionId?.paymentMethod?.brand === undefined
        ? "visa"
        : data?.subscriptionId?.paymentMethod?.brand
    );
  };

  function getCardBrandImage(brand) {
    console.log("Card Brand:", brand);
    switch (brand.toLowerCase()) {
      case "visa":
      case "eftpos":
        return visaImg;
      case "amex":
        return amexImg;
      case "diners":
        return dinersImg;
      case "discover":
        return discoverImg;
      case "jcb":
        return jcbImg;
      case "cartes_bancaires":
        return cartesImg;
      case "unionpay":
        return unionpayImg;
      case "mastercard":
        return masterImg;
      default:
        return visaImg;
    }
  }

  const getImagePath = (notification) => {
     const project = notification?.project?.toLowerCase() || "";
     const title = notification?.title?.toLowerCase() || "";
     const description = notification?.description?.toLowerCase() || "";
     const type = notification?.subscriptionId?.type?.toLowerCase() || "";
 
     if (
       title.includes("file") ||
       project.includes("file") ||
       description.includes("file") ||
       type.includes("file")
     )
       return "files/logo/2025/clikkle%20files.png";
     if (
       title.includes("esign") ||
       title.includes("e-sign") ||
       project.includes("esign") ||
       description.includes("esign") ||
       type.includes("esign")
     )
       return "e-sign/logo/2025/clikkle%20esign.png";
     if (
       title.includes("project") ||
       project.includes("project") ||
       description.includes("project") ||
       type.includes("project")
     )
       return "projects/logo/2025/clikkle%20projects.png";
     if (
       title.includes("chat") ||
       project.includes("chat") ||
       description.includes("chat") ||
       type.includes("chat")
     )
       return "chat/logo/2025/clikkle%20chat.png";
     if (
       title.includes("campaign") ||
       project.includes("campaign") ||
       description.includes("campaign") ||
       type.includes("campaign")
     )
       return "campaigns/logo/2025/clikkle%20campaigns.png";
     if (
       title.includes("app") ||
       title.includes("worksuite") ||
       project.includes("app") ||
       description.includes("worksuite") ||
       type.includes("app") ||
       type.includes("worksuite")
     )
       return "worksuite/2025/clikkle%20worksuite.png";
     if (
       title.includes("ads") ||
       project.includes("ads") ||
       description.includes("ads") ||
       type.includes("ads")
     )
       return "ads/logo/2023/ads.png";
     if (
       title.includes("crm") ||
       project.includes("crm") ||
       description.includes("crm") ||
       type.includes("crm")
     )
       return "crm/2025/clikkle%20crm.png";
     if (
       title.includes("host") ||
       project.includes("host") ||
       description.includes("host") ||
       type.includes("host")
     )
       return "host/logo/2023/host.png";
     if (
       title.includes("launch") ||
       project.includes("launch") ||
       description.includes("launch") ||
       type.includes("launch")
     )
       return "launch/logo/2023/launch.png";
     if (
       title.includes("mail") ||
       project.includes("mail") ||
       description.includes("mail") ||
       type.includes("mail")
     )
       return "cmail/logo/2023/cmail.png";
     if (
       title.includes("pitch") ||
       project.includes("pitch") ||
       description.includes("pitch") ||
       type.includes("pitch")
     )
       return "pitch/logo/2023/pitch.png";
     if (
       title.includes("hr") ||
       project.includes("hr") ||
       description.includes("hr") ||
       type.includes("hr")
     )
       return "hr/logo/2025/clikkle%20hr.png";
 
     // fallback to HR if still nothing
     return "hr/logo/2025/clikkle%20hr.png";
   };
  const { mode } = useCustomTheme();

  return (
    <>
      <Grid container spacing={2} sx={{ padding: 2 }}>
        {data?.map((notification) => {
          const sub = notification.subscriptionId;
          if (!sub) return null;

          const price = Number(sub?.amount) || 0;
          const createdAt = new Date(
            notification.createdAt
          ).toLocaleDateString();

          return (
            <Grid item xs={12} key={notification._id}>
              <Card
                sx={{
                  background: "none",
                  border: mode === "light"
                ? "1px solid #e5e7eb"
                : "1px solid #2e2e2e",
                  cursor: "pointer",
                }}
                onClick={toggleDrawer(true, notification)}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    alignItems: isMobile ? "flex-start" : "center",
                    flexDirection: isMobile ? "column" : "row",
                    justifyContent: "space-between",
                    gap: isMobile ? 2 : 0,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: isMobile ? "row" : "row",
                      alignItems: isMobile ? "flex-start" : "center",
                      gap: 2,
                      width: isMobile ? "100%" : "auto",
                    }}
                  >
                    <Image
                      cdn={getImagePath(notification)}
                      alt={`${notification?.title} Icon`}
                      style={{
                        width: isMobile ? 50 : 70,
                        height: isMobile ? 50 : 70,
                        objectFit: "contain",
                      }}
                    />

                    <Box>
                      <Typography variant="h6">
                        {notification?.title}
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          wordBreak: "break-word",
                          maxWidth: isMobile ? "80%" : "100%",
                          fontSize: isMobile ? "0.85rem" : "1rem",
                        }}
                      >
                        {createdAt}. {notification.description}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: isMobile ? "flex-start" : "center",
                      flexDirection: "column",
                      gap: "10px",
                      mt: isMobile ? 2 : 0,
                      width: isMobile ? "100%" : "auto",
                      textAlign: isMobile ? "left" : "right",
                    }}
                  >
                    <Typography sx={{ fontSize: 12, color: "#aaa" }}>
                      {moment(notification.createdAt).format(
                        "MMM DD, YYYY, h:mm A"
                      )}
                    </Typography>
                    <Typography sx={{ color: "#C5B03D" }}>
                      ${price.toFixed(2)}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* Drawer */}
      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        <Box sx={{ width: isMobile ? "100vw" : 500, padding: 3 }}>
          <Typography variant="h6" gutterBottom>
            Transaction details
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mb={3}
          >
            <Image
              cdn={getImagePath(notification)}
              alt={`Icon`}
              style={{
                width: "18%",
                height: "18%",
                objectFit: "contain",
              }}
            />
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography fontWeight="bold" gutterBottom>
              {notification?.description}
            </Typography>
            <Typography variant="h5" gutterBottom>
              ${Number(notification?.subscriptionId?.amount).toFixed(2)}
            </Typography>
          </Box>

          <Divider sx={{ mb: 2 }} />
          <Box mt={3}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <Typography color="#A5A5A5">Date</Typography>
                <Typography mb={2}>
                  {moment(notification?.createdAt).format("MMM DD, YYYY")}
                </Typography>
              </div>
              <div style={{ textAlign: "right" }}>
                <Typography color="#A5A5A5">Time</Typography>
                <Typography mb={2}>
                  {moment(notification?.createdAt).format("h:mm A")}
                </Typography>
              </div>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: isMobile ? "flex-start" : "space-around",
                mt: 3,
                gap: isMobile ? 2 : 0,
              }}
            >
              <div>
                <Typography color="#A5A5A5">Quantity</Typography>
                <Typography mb={2}>1</Typography>
              </div>
              <div style={{ width: isMobile ? "100%" : "70%" }}>
                <Typography color="#A5A5A5">Item</Typography>
                <Typography mb={2}>
                  {moment(notification?.createdAt).format("MMM DD, YYYY")}{" "}
                  Unlock access + limited access to{" "}
                  {notification?.subscriptionId?.plan?.name} plan
                </Typography>
              </div>
              <div style={{ textAlign: isMobile ? "left" : "right" }}>
                <Typography color="#A5A5A5">Price</Typography>
                <Typography mb={2}>
                  ${notification?.subscriptionId?.plan?.amount}
                </Typography>
              </div>
            </Box>

            <Divider sx={{ my: 2 }} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography>Subtotal:</Typography>
              <Typography>${notification?.subscriptionId?.amount}</Typography>
            </Box>

            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography>VAT:</Typography>
              <Typography> $1.52</Typography>
            </Box> */}

            <Divider sx={{ my: 2 }} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography fontWeight="bold">Total:</Typography>
              <Typography fontWeight="bold">
                ${Number(notification?.subscriptionId?.amount)?.toFixed(2)}
              </Typography>
            </Box>

            <Divider sx={{ my: 2 }} />
            <Box sx={{ mt: 2 }}>
              <Typography color="#A5A5A5">Status</Typography>
              <Typography>Completed</Typography>
            </Box>

            <Box sx={{ mt: 2 }}>
              {/* <Typography color="#A5A5A5">Transaction ID</Typography>
              <Typography>GPA.3251-2963-1250-24975</Typography> */}
            </Box>

            <Box
              sx={{
                mt: 2,
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "space-between",
                alignItems: "center",
                gap: isMobile ? 1 : 0,
              }}
            >
              <div>
                <Typography color="#A5A5A5">Payment Method</Typography>
                <Typography>
                  {notification?.subscriptionId?.paymentMethod?.brand}****
                  {notification?.subscriptionId?.paymentMethod?.last4}
                </Typography>
              </div>
              <div
                style={{
                  padding: 3,
                  border: "1px solid rgb(85, 85, 85)",
                  marginTop: isMobile ? 10 : 0,
                }}
              >
                <img
                  src={getCardBrandImage(CardImg)}
                  width="30"
                  height="30"
                  alt="mastercard"
                />
              </div>
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* <Typography color="#A5A5A5">Purchased From:</Typography>
            <Typography>
              BigFish PTE LTD, Nigel Crasto <br />
              51 Goldhill Plaza #07-10/11 <br />
              308900, Singapore
            </Typography> */}

            <Typography mt={2} color="#A5A5A5">
              Questions or Concerns
            </Typography>
            <Typography mt={1}>
              Contact:{" "}
              <a
                href="https://worksuite.clikkle.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#0080FF" }}
              >
                Clikkle Technologies
              </a>
            </Typography>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default ActivityDetails;
